module.exports = __webpack_public_path__ + "static/media/GinVita.bca74756.png";